import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const CookieBanner = () => {
  const { t } = useTranslation();
  const [acceptedCookies, setAcceptedCookies] = useState(false);

  useEffect(() => {
    const cookiesAccepted = localStorage.getItem('cookiesAccepted');
    if (cookiesAccepted === 'true') {
      setAcceptedCookies(true);
    }
  }, []);

  const handleAcceptCookies = () => {
  localStorage.setItem('cookiesAccepted', 'true');
  setAcceptedCookies(true);
  };


  return (
    <div className={`${acceptedCookies ? 'hidden' : 'block'}`}>
      <div className="cookie-banner fixed bottom-0 left-0 z-40 w-full border-t border-white/10 bg-night-800/95 backdrop-blur">
        <div className="mx-auto flex max-w-7xl flex-col px-4 py-4 sm:flex-row sm:items-center sm:px-6 lg:px-8">
          <p className="mb-3 text-sm font-medium text-ink-200 sm:mb-0 sm:mr-4">
            {t('cookie-banner-text')}
          </p>
          <button
            onClick={handleAcceptCookies}
            className="cookie-banner__button ml-0 shrink-0 rounded-full bg-signal-500 px-5 py-2 text-sm font-bold uppercase tracking-wide text-white transition-colors hover:bg-signal-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-night-800 focus:ring-signal-500 sm:ml-auto"
          >
            {t('cookie-banner-accept')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
